/* eslint-disable */

import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import store, { history } from './redux/store';
import './css/index.css';

const onServiceWorkerUpdate = () => {
  console.log( 'We have detected an update' );
};

const app = document.querySelector( '#root' );
render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <App />
    </ConnectedRouter>
  </Provider>,
  app
);

registerServiceWorker( onServiceWorkerUpdate );



// WEBPACK FOOTER //
// ./src/index.js